// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListLocationsQueryVariables = Types.Exact<{
  pageNumber: Types.InputMaybe<Types.Scalars['Int']['input']>;
  pageSize: Types.InputMaybe<Types.Scalars['Int']['input']>;
  enabled: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  keyword: Types.InputMaybe<Types.Scalars['String']['input']>;
  hasEmployees?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  onlyIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;

export type ListLocationsQuery = { __typename?: 'Query' } & {
  listLocations: { __typename?: 'ListLocations' } & Pick<Types.ListLocations, 'totalCount'> & {
      items: Array<
        { __typename?: 'Location' } & Pick<
          Types.Location,
          'id' | 'name' | 'enabled' | 'createdAt' | 'updatedAt' | 'countryId'
        > & { country: Types.Maybe<{ __typename?: 'Country' } & Pick<Types.Country, 'name'>> }
      >;
    };
};

export const ListLocationsDocument = /*#__PURE__*/ gql`
    query listLocations($pageNumber: Int, $pageSize: Int, $enabled: Boolean, $keyword: String, $hasEmployees: Boolean = null, $onlyIds: [ID!] = null) {
  listLocations(
    filter: {pageNumber: $pageNumber, pageSize: $pageSize, enabled: $enabled, keyword: $keyword, hasEmployees: $hasEmployees, onlyIds: $onlyIds}
  ) {
    items {
      id
      name
      enabled
      createdAt
      updatedAt
      countryId
      country {
        name
      }
    }
    totalCount
  }
}
    `;

/**
 * __useListLocationsQuery__
 *
 * To run a query within a React component, call `useListLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLocationsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      enabled: // value for 'enabled'
 *      keyword: // value for 'keyword'
 *      hasEmployees: // value for 'hasEmployees'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useListLocationsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListLocationsQuery, ListLocationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListLocationsQuery, ListLocationsQueryVariables>(ListLocationsDocument, options);
}
export function useListLocationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListLocationsQuery, ListLocationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListLocationsQuery, ListLocationsQueryVariables>(ListLocationsDocument, options);
}
// @ts-expect-error
export function useListLocationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListLocationsQuery, ListLocationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListLocationsQuery, ListLocationsQueryVariables>;
export function useListLocationsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLocationsQuery, ListLocationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListLocationsQuery | undefined, ListLocationsQueryVariables>;
export function useListLocationsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLocationsQuery, ListLocationsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListLocationsQuery, ListLocationsQueryVariables>(ListLocationsDocument, options);
}
export type ListLocationsQueryHookResult = ReturnType<typeof useListLocationsQuery>;
export type ListLocationsLazyQueryHookResult = ReturnType<typeof useListLocationsLazyQuery>;
export type ListLocationsSuspenseQueryHookResult = ReturnType<typeof useListLocationsSuspenseQuery>;
